"use client"

import posthog from "posthog-js"
import { useEffect, useState } from "react"
import { ExperimentKey, experiments, ExperimentVariant } from "./experiments"

export function useExperiment<Key extends ExperimentKey>(key: Key) {
  const [loading, setLoading] = useState(true)
  const [variant, setVariant] = useState<ExperimentVariant<Key>>("control")

  useEffect(() => {
    posthog.onFeatureFlags(() => {
      const variant = posthog.getFeatureFlag(key) as ExperimentVariant<Key>

      console.debug(`🎛️ Experiment ${key} variant:`, variant)
      setVariant(variant)
      setLoading(false)
    })
  }, [key])

  return { loading, variant }
}

export function getExperimentVariants<Key extends ExperimentKey>(key: Key) {
  return experiments[key]
}

export function setLocalExperimentVariant<Key extends ExperimentKey>(key: Key, value: ExperimentVariant<Key>) {
  posthog.featureFlags.overrideFeatureFlags({ flags: { [key]: value } })
}

export function captureTestConversion() {
  posthog.capture("test_conversion")
}

export { posthog as posthogBrowser }
